import { createFileRoute, notFound } from '@tanstack/react-router';

import PrivacyPolicyPage from '@/pages/privacy-policy/PrivacyPolicyPage';
import { getHomeHeaderButton } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { getPrivacyPolicy } from '@/sanity/privacy-policy';
import { privacyPolicyPath } from '@/utils/privacy-policy';
import { buildPageMeta } from '@/utils/seo';

const privacyTitle = 'Privacy policy — Budgy';
const privacyDescription =
  'Privacy policy for Budgy and Rodeo, operated by Lightning Riders Ltd.';

export const Route = createFileRoute('/privacy-policy')({
  loader: async () => {
    const [privacyPolicy, headerButton, legalLinks] = await Promise.all([
      getPrivacyPolicy(),
      getHomeHeaderButton(),
      getLegalLinks(),
    ]);
    if (!privacyPolicy) {
      throw notFound();
    }

    return { headerButton, legalLinks, privacyPolicy };
  },
  component: PrivacyPolicyPage,
  head: () =>
    buildPageMeta({
      title: privacyTitle,
      description: privacyDescription,
      path: privacyPolicyPath,
    }),
});
